import { type PropsWithChildren, useEffect } from 'react'
import { Modal } from '../Modal'
import { useFabulousMenu } from './context'

type Props = PropsWithChildren<{
  title: string
}>

export const FabulousMenu = ({ children, title }: Props) => {
  const { isOpen, closeMenu, registerMenu } = useFabulousMenu()

  /**
   * We let our composition know we are rendered so they understand its the variant
   * with a menu to choose more options from.
   *
   * Inside your menu items you can close our Menu by using
   * `closeMenu` from the given `useFabulousMenu`
   */
  useEffect(() => {
    registerMenu(true)

    return () => {
      registerMenu(false)
    }
  }, [registerMenu])

  return (
    <Modal open={isOpen} onClose={closeMenu}>
      <Modal.Header title={title} onClose={closeMenu} />
      <Modal.Content noPaddingSides>{children}</Modal.Content>
    </Modal>
  )
}
